import script from "./TreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeNode.vue?vue&type=script&setup=true&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=bf8f8a5c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf8f8a5c"]])

export default __exports__